/**
 * Created Jie Gao on 2020-07-14.
 */

import {
    ISymbolStateConfig,
    SymbolStateTransition
} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TimelineLite, TweenLite} from "gsap";
import {WinterHoardGameConfig} from "../WinterHoardGameConfig";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {WinterHoardReelSymbol} from "./WinterHoardReelSymbol";

export class WinterHoardReelSymbolWild extends WinterHoardReelSymbol {

    private _wildIdle: TimelineSprite;

    constructor(symName: string, reelId: number, state?: ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    protected initAnimations(): void {
        super.initAnimations();
    }

    protected addNewStateAnimation(timeline: TimelineLite, newState: SymbolStateTransition, stateAnimation: TimelineSprite, delay: number): void {
        super.addNewStateAnimation(timeline, newState, stateAnimation, delay);

        if (newState.state.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.normal.keyword) {
            const winTl: TimelineLite = new TimelineLite();
            winTl.add([
                new TweenLite(this.scale, 0.1, {x: 1, y: 1})
            ]);
            timeline.add(winTl, delay);
            return;
        }
    }

    public playIdleSpine(): void {
        if (this.currentState!.keyword === WinterHoardGameConfig.instance.SYMBOL_STATES.noWin.keyword) {
            return;
        }
        if (!this._wildIdle) {
            this.createIdleAnimation();
        }
        this.addChild(this._wildIdle);
        this._wildIdle.getAnimationAutoShowHide(true, true);
    }

    private createIdleAnimation(): void {
        this._wildIdle = new TimelineSprite(GameResources.getTextures("wildIdle"));
        this._wildIdle.name = "wildIdle";
        this._wildIdle.anchor.set(0.5, 0.5);
        this._wildIdle.position.set(1, 5);
        this._wildIdle.hide();
    }
}